// All Arab League countries with dial codes, national phone length range, and
// governorates / major cities. Used in Checkout so a city can't be chosen
// outside the selected country, and the phone must match the country dial code.
// Palestine is listed first.

export const ARAB_COUNTRIES = [
  { code: "PS", name: "فلسطين", dial: "+970", min: 9, max: 9, cities: [
    "القدس", "رام الله والبيرة", "نابلس", "الخليل", "بيت لحم", "جنين", "طولكرم",
    "قلقيلية", "سلفيت", "طوباس", "أريحا والأغوار", "غزة", "شمال غزة", "دير البلح", "خان يونس", "رفح",
  ]},
  { code: "JO", name: "الأردن", dial: "+962", min: 9, max: 9, cities: [
    "عمّان", "إربد", "الزرقاء", "المفرق", "البلقاء", "مادبا", "الكرك", "الطفيلة", "معان", "العقبة", "جرش", "عجلون",
  ]},
  { code: "LB", name: "لبنان", dial: "+961", min: 7, max: 8, cities: [
    "بيروت", "جبل لبنان", "الشمال", "عكّار", "البقاع", "بعلبك الهرمل", "الجنوب", "النبطية",
  ]},
  { code: "SY", name: "سوريا", dial: "+963", min: 9, max: 9, cities: [
    "دمشق", "ريف دمشق", "حلب", "حمص", "حماة", "اللاذقية", "طرطوس", "إدلب", "درعا", "السويداء",
    "القنيطرة", "دير الزور", "الرقة", "الحسكة",
  ]},
  { code: "EG", name: "مصر", dial: "+20", min: 10, max: 10, cities: [
    "القاهرة", "الجيزة", "الإسكندرية", "الدقهلية", "الشرقية", "القليوبية", "كفر الشيخ", "الغربية",
    "المنوفية", "البحيرة", "الإسماعيلية", "بورسعيد", "السويس", "دمياط", "الفيوم", "بني سويف",
    "المنيا", "أسيوط", "سوهاج", "قنا", "الأقصر", "أسوان", "البحر الأحمر", "الوادي الجديد",
    "مطروح", "شمال سيناء", "جنوب سيناء",
  ]},
  { code: "SA", name: "السعودية", dial: "+966", min: 9, max: 9, cities: [
    "الرياض", "مكة المكرمة", "المدينة المنورة", "القصيم", "المنطقة الشرقية", "عسير", "تبوك",
    "حائل", "الحدود الشمالية", "جازان", "نجران", "الباحة", "الجوف",
  ]},
  { code: "AE", name: "الإمارات", dial: "+971", min: 8, max: 9, cities: [
    "أبوظبي", "دبي", "الشارقة", "عجمان", "أم القيوين", "رأس الخيمة", "الفجيرة",
  ]},
  { code: "QA", name: "قطر", dial: "+974", min: 8, max: 8, cities: [
    "الدوحة", "الريان", "الوكرة", "الخور", "أم صلال", "الشمال", "الظعاين", "الشحانية",
  ]},
  { code: "BH", name: "البحرين", dial: "+973", min: 8, max: 8, cities: [
    "المنامة", "المحرق", "المنطقة الشمالية", "المنطقة الجنوبية",
  ]},
  { code: "KW", name: "الكويت", dial: "+965", min: 8, max: 8, cities: [
    "العاصمة", "حولي", "الفروانية", "مبارك الكبير", "الأحمدي", "الجهراء",
  ]},
  { code: "OM", name: "عُمان", dial: "+968", min: 8, max: 8, cities: [
    "مسقط", "ظفار", "مسندم", "البريمي", "الداخلية", "شمال الباطنة", "جنوب الباطنة",
    "شمال الشرقية", "جنوب الشرقية", "الظاهرة", "الوسطى",
  ]},
  { code: "YE", name: "اليمن", dial: "+967", min: 9, max: 9, cities: [
    "صنعاء", "عدن", "تعز", "الحديدة", "إب", "ذمار", "حضرموت", "حجة", "المحويت", "صعدة",
    "مأرب", "الجوف", "البيضاء", "لحج", "أبين", "شبوة", "المهرة", "عمران", "الضالع", "ريمة", "سقطرى",
  ]},
  { code: "IQ", name: "العراق", dial: "+964", min: 10, max: 10, cities: [
    "بغداد", "البصرة", "نينوى", "أربيل", "النجف", "كربلاء", "ذي قار", "بابل", "الأنبار",
    "ديالى", "كركوك", "صلاح الدين", "واسط", "ميسان", "المثنى", "القادسية", "دهوك", "السليمانية",
  ]},
  { code: "LY", name: "ليبيا", dial: "+218", min: 9, max: 9, cities: [
    "طرابلس", "بنغازي", "مصراتة", "الزاوية", "سبها", "البيضاء", "طبرق", "سرت", "درنة", "غات", "الكفرة",
  ]},
  { code: "TN", name: "تونس", dial: "+216", min: 8, max: 8, cities: [
    "تونس", "صفاقس", "سوسة", "أريانة", "بن عروس", "نابل", "بنزرت", "القيروان", "قابس", "قفصة",
    "المنستير", "المهدية", "جندوبة", "باجة", "زغوان", "سليانة", "الكاف", "سيدي بوزيد",
    "قصرين", "توزر", "قبلي", "مدنين", "تطاوين", "منوبة",
  ]},
  { code: "DZ", name: "الجزائر", dial: "+213", min: 9, max: 9, cities: [
    "الجزائر", "وهران", "قسنطينة", "عنابة", "البليدة", "باتنة", "سطيف", "تلمسان", "بجاية",
    "تيزي وزو", "ورقلة", "غرداية", "بسكرة", "الوادي", "تمنراست", "أدرار",
  ]},
  { code: "MA", name: "المغرب", dial: "+212", min: 9, max: 9, cities: [
    "الرباط سلا القنيطرة", "الدار البيضاء سطات", "فاس مكناس", "مراكش آسفي", "طنجة تطوان الحسيمة",
    "الشرق", "بني ملال خنيفرة", "درعة تافيلالت", "سوس ماسة", "كلميم واد نون",
    "العيون الساقية الحمراء", "الداخلة وادي الذهب",
  ]},
  { code: "SD", name: "السودان", dial: "+249", min: 9, max: 9, cities: [
    "الخرطوم", "الجزيرة", "كسلا", "القضارف", "البحر الأحمر", "نهر النيل", "الشمالية", "شمال كردفان",
    "جنوب كردفان", "شمال دارفور", "جنوب دارفور", "غرب دارفور", "سنار", "النيل الأبيض", "النيل الأزرق", "شمال دارفور",
  ]},
  { code: "MR", name: "موريتانيا", dial: "+222", min: 8, max: 8, cities: [
    "نواكشوط", "نواذيبو", "آدرار", "العصابة", "البراكنة", "كيدي ماغا", "كوركول", "تكانت",
    "تيرس زمور", "اترارزة", "لعصابة",
  ]},
  { code: "SO", name: "الصومال", dial: "+252", min: 8, max: 8, cities: [
    "مقديشو", "هرجيسا", "بوصاصو", "كيسمايو", "بيدوا", "غالكايو", "بربرة", "مركا",
  ]},
  { code: "DJ", name: "جيبوتي", dial: "+253", min: 8, max: 8, cities: [
    "جيبوتي", "علي صبيح", "دخيل", "أوبوك", "طاجورة", "أرتا",
  ]},
  { code: "KM", name: "جزر القمر", dial: "+269", min: 7, max: 7, cities: [
    "موروني", "القمر الكبرى", "أنجوان", "موهيلي",
  ]},
];

export const ARAB_COUNTRY_MAP = Object.fromEntries(ARAB_COUNTRIES.map((c) => [c.code, c]));

// Only digits, length within the country's national number range.
export function validatePhone(countryCode, national) {
  const c = ARAB_COUNTRY_MAP[countryCode];
  if (!c) return false;
  const digits = (national || "").replace(/\D/g, "");
  return digits.length >= c.min && digits.length <= c.max;
}
